import createAction from '../services/create-action';

export const SET_USER_AGENT = 'userAgent/SET';

export const setUserAgent = createAction(SET_USER_AGENT);



// WEBPACK FOOTER //
// ./app/actions/set-user-agent.js